import React from "react";
import "../SCSS/styles.css";
import MetaTags from "react-meta-tags";
import { getLink } from "../../../../Common/functions";

function NewsroomMediaThree() {
  return (
    <div className="newsroom-media-three-container">
      <MetaTags>
        <title>
          Updapt Unveils Climate Risk Analysis Module to boost Financial
          Resilience
        </title>
        <meta
          name="description"
          content="Updapt Unveils Climate Risk Analysis Module to boost Financial Resilience"
        />
        <meta
          property="og:title"
          content="UpdaptCSR | Sustainability Platform"
        />
      </MetaTags>
      <div className="blog-title">
        Updapt Unveils Climate Risk Analysis Module to boost Financial
        Resilience
        <br />
        Transforming climate risks into business resilience with real-time
        analysis and insights
      </div>
      <div className="blog-picture">
        <figure>
          <img
            className="picture"
            src={require("../../../../../assets/Media/cram_pr.webp")}
            alt="Climate Risk Analysis Module"
            loading="lazy"
          />
        </figure>
      </div>
      <p>
        As climate change alters the financial markets and operational business
        functions, Updapt, a leading ESG SaaS solutions provider is delighted to
        announce the launch of our intuitive Climate Risk Analysis and
        Management (CRAM) Module. This intelligent platform will enable
        organizations across industry sectors to identify, assess, simulate and
        mitigate climate related risks across all business assets and locations.
      </p>
      <p>
        Climate change and risks associated with changes in the environment have
        always been a threat to business materiality. With increasing regulatory
        and investor scrutiny across ESG parameters and associated risks, the
        CRAM module enables organizations to leverage their risk identification
        and mitigation, with a data-driven approach towards building climate
        resilience. “The module encourages organizations to embed climate
        intelligence into the company’s strategy for holistic decision-making
        and strategy planning across business operations.
      </p>
      <p>
        <div className="sub-heading">Key features of the CRAM module:</div>
        <ul>
          <li>
            <b>Comprehensive risk analysis</b>: Tool enables the company to
            identify, assess and mitigate both physical risks such as floods,
            droughts, heatwaves, and transition risks such as carbon pricing,
            policy and regulatory modifications – in an integrated and unified
            platform
          </li>
          <li>
            <b>Scenario Based Forecasting and Analysis</b>: Run live simulations
            in the module for a stress test business approach for risks across
            various climate-related pathways aligned to{" "}
            {getLink(
              "IPCC’s Shared Socio-Economic pathways",
              "https://ourworldindata.org/explorers/ipcc-scenarios?pickerSort=asc&pickerMetric=entityName&Metric=Electricity+capacity&Rate=Total&Region=Global&country=SSP1+-+Baseline~SSP2+-+Baseline~SSP3+-+Baseline~SSP4+-+Baseline~SSP5+-+Baseline"
            )}
            ,{" "}
            {getLink(
              "IEA’s Net Zero 2050",
              "https://www.iea.org/reports/net-zero-by-2050"
            )}
            ,{" "}
            {getLink(
              "NGFS transitions",
              "https://www.ngfs.net/ngfs-scenarios-portal/"
            )}
            , among others.
          </li>
          <li>
            <b>Mitigate and Act</b>: Transform your data to elevate your board
            room discussions to future proof the organization, with built in
            mitigation strategies, tracking of owners and stakeholders assigned
            across the risk profile, and monitoring of Key Performance
            Indicators
          </li>
          <li>
            <b>Compliance and Beyond</b>: Leverage the module’s AI and ML
            capabilities to generate audit-ready reports aligned with
            international frameworks and guidelines such as TCFD, NGFS, ISO
            14091, and CSRD.
          </li>
        </ul>
      </p>
      <p>
        <div className="sub-heading">Updapt’s Value Proposition</div>
        <ul>
          <li>
            Location-specific risk tracking and monitoring at site, asset and
            facility levels across business operations
          </li>
          <li>
            Visualize risk exposure across geographies and map risk scores, risk
            assessment matrix and financial impacts across identified risks to
            strategize and turn risks into opportunities
          </li>
          <li>
            Flexible scoring methodology for manual, automated, or dual mode of
            risk tracking and analysis based on organizational preferences
            maintaining an industry agnostic approach
          </li>
          <li>
            Engage stakeholders to eliminate green washing through survey
            assessments mapped across the company’s climate risk register{" "}
          </li>
          <li>
            Scenario explorer to run simulations across various climate pathways
            to identify top impacted locations, associated financial impacts and
            a risk severity heatmap
          </li>
          <li>
            Configurable dashboards showcasing the organization’s risk profile
            across locations, top high-risk facilities, risk trends and
            distribution, and mitigations plans and progress
          </li>
          <li>
            A unified ecosystem working seamlessly with your real-time ESG
            database – across GHG emissions, insights from double materiality
            assessments, and value chain metrics
          </li>
        </ul>
      </p>
    </div>
  );
}

export default NewsroomMediaThree;
